/* eslint-disable react/no-unescaped-entities */
/* eslint-disable quotes */
import React from 'react'
import Section from '../components/Section'
import FilterItem from '../components/Atoms/FilterItem'

function Categories() {
	let toggleDropdown = e => {
		e.currentTarget.classList.toggle('active')
	}

	let categoryListArr = [
		'Tops',
		'Bottoms',
		'Dresses',
		"Women's Yoga",
		'Bathing Suits',
		'Outer Wear',
		'Lingerie + Loungewear',
		'All Womens'
	]

	return (
		<div className='main-container'>
			<Section className='height-auto'>
				<div className='container'>
					<div className='row justify-content-center'>
						<div className='col-sm-8 col-md-7 text-center'>
							<h2>Women</h2>
						</div>
					</div>
				</div>
			</Section>

			<Section id='category__section'>
				<div className='col-12'>
					<nav aria-label='breadcrumb'>
						<ol className='breadcrumb'>
							<li className='breadcrumb-item'>
								<a href='/'>Home</a>
							</li>
							<li
								className='breadcrumb-item active'
								aria-current='page'>
								Women
							</li>
						</ol>
					</nav>
				</div>
				<div className='col-md-3'>
					<div className='el--sticky'>
						<h4>Category:</h4>
						{/* Filter Column */}
						<ul>
							<li>
								<span
									className='active'
									onClick={toggleDropdown}>
									Women
								</span>
								<span className='plus-symbol' />
								<ul className='expandable-el'>
									{categoryListArr.map((category, i) => {
										return (
											<li key={i}>
												<a href='/category/subcategory'>
													{category}
												</a>
											</li>
										)
									})}
								</ul>
							</li>
							<li>
								<span onClick={toggleDropdown}>
									New Arrivals
								</span>
								<span className='plus-symbol' />
								<ul className='expandable-el'>
									<FilterItem>brand 1</FilterItem>
									<FilterItem>brand 2</FilterItem>
									<FilterItem>brand 3</FilterItem>
									<FilterItem>brand 4</FilterItem>
									<FilterItem>brand 5</FilterItem>
								</ul>
							</li>
							<li>
								<span onClick={toggleDropdown}>Featured</span>
								<span className='plus-symbol' />
								<ul className='expandable-el'>
									<li>
										<a href='/category/subcategory'>
											Women's Brands
										</a>
									</li>
									<li>
										<a href='/category/subcategory'>
											Women's under $100
										</a>
									</li>
									<li>
										<a href='/category/subcategory'>
											The Etho Top Picks
										</a>
									</li>
								</ul>
							</li>
							<li>
								<span onClick={toggleDropdown}>Price</span>
								<span className='plus-symbol' />
								<ul className='expandable-el'>
									<FilterItem>under $50</FilterItem>
									<FilterItem>$50 - $100</FilterItem>
									<FilterItem>over $100</FilterItem>
								</ul>
							</li>
							<li>
								<span onClick={toggleDropdown}>Size</span>
								<span className='plus-symbol' />
								<ul className='expandable-el'>
									<FilterItem>xs</FilterItem>
									<FilterItem>sm</FilterItem>
									<FilterItem>md</FilterItem>
									<FilterItem>lg</FilterItem>
									<FilterItem>xl</FilterItem>
								</ul>
							</li>
						</ul>
					</div>
				</div>
				<div className='col-md-9'>
					{/* List of Categories */}
					<div className='row'>
						{categoryListArr.map((category, i) => {
							return (
								<div className='col-md-4' key={i}>
									<a
										href='/category/subcategory'
										className='card'>
										<div className='card-img-top'>
											<img
												src='https://placehold.it/240x360'
												alt='placeholder'
											/>
										</div>
										<div className='card-body'>
											<h4 className='card-title'>
												{category}
											</h4>
											<p className='card-text'>
												Lorem ipsum dolor sit amet
												consectetur, adipisicing elit.
												Sint magni, impedit ullam quo
												placeat est incidunt explicabo
												iusto iure iste!
											</p>
										</div>
									</a>
								</div>
							)
						})}
					</div>
				</div>
			</Section>

			<Section id='cta__section'>
				<div className='col-md-6'>
					<img src='https://placehold.it/600x400' alt='placeholder' />
				</div>
				<div className='col-md-6'>
					<img src='https://placehold.it/600x400' alt='placeholder' />
				</div>
			</Section>
		</div>
	)
}

export default Categories
